<template>
  <section class="hero is-primary is-medium">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">Phasmophobia</h1>
        <h2 class="subtitle">Ghost Journal</h2>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
@import '@/utils.scss';
@import 'bulma/sass/layout/hero';
@import 'bulma/sass/elements/container';
@import 'bulma/sass/elements/title';
</style>
